var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{on:{"leave":_vm.leave}},[_c('a-plane',{attrs:{"material":"shader: flat","width":"8","height":"8","color":"#000","opacity":"0"}},[_c('a-image',{ref:"text",attrs:{"src":_vm.cdn(require('./img/explorer-' + _vm.lang + '.png')),"height":".5","width":.5,"opacity":"0","shader":"flat"},on:{"materialtextureloaded":_vm.enter}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-398b7262","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/explorer/Explorer.vue
// module id = null
// module chunks = 